import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { VersionUpdateService } from '@app/core/services/version-update.service';

@Component({
  selector: 'app-version-update-banner',
  imports: [TranslatePipe, ButtonDirective],
  templateUrl: './version-update-banner.component.html',
  styleUrl: './version-update-banner.component.css',
})
export class VersionUpdateBannerComponent {
  protected readonly versionUpdateService = inject(VersionUpdateService);

  public refreshPage(): void {
    globalThis.location.reload();
  }
}
